import { useQueryClient } from '@tanstack/react-query'
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAdminAuth } from '~/entities/session/model/use-admin-auth'
import { AdminLayout } from '~/features/admin/admin-layout'
import * as m from '~/paraglide/messages'
import { CacheScope, clearScope } from '~/shared/lib/query-keys'
import { storageManager } from '~/shared/lib/storage-manager'

export const Route = createFileRoute('/admin')({
  component: AdminRoute,
})

function AdminRoute() {
  const { isAuthenticated, isLoading } = useAdminAuth()
  const queryClient = useQueryClient()

  // Clear any leftover business viewing context when arriving at /admin
  // (handles browser back button navigation)
  useEffect(() => {
    if (storageManager.getAdminViewingBusinessId()) {
      clearScope(queryClient, CacheScope.BUSINESS)
      storageManager.clearAdminViewingContext()
    }
  }, [queryClient])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="border-blue-600 border-t-4 rounded-full w-12 h-12 animate-spin" />
          <p className="text-slate-600 dark:text-slate-400 text-sm">{m.loading()}</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" search={{ reason: 'forbidden' }} />
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  )
}
